import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/avatar/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p>{`Avatars provide a container for displaying Entity or User images on Thumbtack. This `}<inlineCode parentName="p">{`UIView`}</inlineCode>{` container displays either the filled images after loading the image via URL or the blank Avatar view if there’s no backing image and initials are provided.`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`EntityAvatar`}</inlineCode>{` or `}<inlineCode parentName="p">{`UserAvatar`}</inlineCode>{` classes directly depending on the object to be displayed.`}</p>
    <div>
    <b>Entity</b>: a company, business, or service.
    </div>
    <div>
    <b>User</b>: a person or user.
    </div>
    <p><img parentName="p" {...{
        "src": "/img/ios/avatar-variations.png",
        "alt": "Screenshot of Entity and User Avatars"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let entityAvatar = EntityAvatar(size: .medium)
entityAvatar.name = "Nicolas Cage"
entityAvatar.initials = "NC"
entityAvatar.setImageURL(avatarImageURL)

let userAvatar = UserAvatar(size: .medium)
userAvatar.name = "Nicolas Cage"
userAvatar.initials = "NC"
userAvatar.setImageURL(avatarImageURL)
`}</code></pre>
    <h2>{`Accessibility`}</h2>
    <p>{`Provide the `}<inlineCode parentName="p">{`name`}</inlineCode>{` property to override the view’s accessibility label. If not provided, the accessibility label will be `}<inlineCode parentName="p">{`nil`}</inlineCode>{`.`}</p>
    <h2>{`Public API`}</h2>
    <h3><inlineCode parentName="h3">{`public var image: UIImage?`}</inlineCode></h3>
    <p>{`The image displayed in the avatar image view.`}</p>
    <h3><inlineCode parentName="h3">{`public var size: Avatar.Size`}</inlineCode></h3>
    <p>{`One of the provided avatar sizes: `}<inlineCode parentName="p">{`xSmall`}</inlineCode>{`, `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, `}<inlineCode parentName="p">{`large`}</inlineCode>{`, `}<inlineCode parentName="p">{`xLarge`}</inlineCode></p>
    <h3><inlineCode parentName="h3">{`public var isOnline: Bool`}</inlineCode></h3>
    <p>{`Boolean value that controls whether the online badge is shown or not.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/avatar-online-now.png",
        "alt": "Screenshot of Online Badge on Entity and User Avatar"
      }}></img></p>
    <h3><inlineCode parentName="h3">{`public var initials: String?`}</inlineCode></h3>
    <p>{`The initials to be shown when displaying the blank avatar. Any string longer than one character will be truncated for display.`}</p>
    <h3><inlineCode parentName="h3">{`public var name: String?`}</inlineCode></h3>
    <p>{`Used for accessibility label for the avatar.`}</p>
    <h3><inlineCode parentName="h3">{`public init(size: Avatar.Size, initials: String? = nil, name: String? = nil, isOnline: Bool = false)`}</inlineCode></h3>
    <p>{`Initializes an EntityAvatar/UserAvatar. Parameters: size: The initial `}<inlineCode parentName="p">{`Avatar.Size`}</inlineCode>{` class for the component. initials: Any string longer that one character will be truncated for display. name: Used for accessibility label for the avatar.`}</p>
    <p><em parentName="p">{`Note`}</em>{` A URL extension is provided for utility for loading a remote image. It is not part of the core Thumbprint API as it relies on SDWebImage.`}</p>
    <h3><inlineCode parentName="h3">{`func setImageURL(_ url: URL?) -> SDWebImageOperation?`}</inlineCode></h3>
    <p>{`Loads an image from the given URL and sets a blank placeholder image while loading. Once loaded, the image is displayed in the Avatar.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      